import styled from 'styled-components'

import { px2rem, mq } from '@utils'
import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'
import tokensRenamed from '@constants/tokensRenamed'

const Styles = styled.div`
  margin-bottom: ${px2rem(40)};
  position: relative;

  header {
    > .ui.header:not(:last-child) {
      margin-bottom: ${px2rem(8)};
    }

    > h1 {
      ${mq.lessThan('largestMobile')`
        font-size: ${tokens.fontSize[6].value};
        line-height: ${tokensRenamed.lineHeights[9].value};
      `}
    }

    > h5 {
      font-weight: ${tokens.fontWeights.artBaselText1.value} !important;
      line-height: ${tokensRenamed.lineHeights[7].value} !important;
    }
  }

  .ui.list {
    margin-bottom: ${px2rem(40)};

    > .item {
      &:not(:last-child) {
        padding-bottom: ${px2rem(20)};
        ${mq.lessThan('largestMobile')`
          padding-bottom: ${px2rem(16)};
        `}
      }

      > svg {
        margin: 0 !important;
      }

      > .icon {
        .favorite-icon {
          padding: ${px2rem(1)};
        }

        svg {
          position: relative;
          top: ${px2rem(3)};
        }

        + .content {
          padding-left: ${px2rem(8)};
        }
      }
    }
  }

  .ui.grid {
    .event-detail__image-wrapper {
      ${mq.lessThan('largestMobile')`
        margin-bottom: ${px2rem(40)};
      `}

      > div:first-child {
        > img {
          width: 100%;
          ${mq.lessThan('largestMobile')`
            max-width: unset;
            width: calc(100% + ${px2rem(40)});
            margin-left: ${px2rem(-20)};
            margin-right: ${px2rem(-20)};
          `}
        }

        margin-bottom: ${px2rem(40)};
        ${mq.lessThan('largestMobile')`
          margin-bottom: ${px2rem(15)};
        `}
      }
    }
  }

  .event-detail__padded-area {
    padding-left: ${px2rem(32)};
  }

  .event-detail__description {
    font-size: ${tokens.fontSize[2].value};
    line-height: ${tokensRenamed.lineHeights[6].value};
    ${mq.greaterThan('desktop')`
      padding-right: ${px2rem(30)};
    `}
  }

  .event-detail__actions {
    display: flex !important;
    justify-content: flex-end;
    align-items: flex-start;

    button {
      margin: 0 0 0 ${px2rem(40)};
      min-width: ${px2rem(95)};
    }
  }

  a {
    div {
      color: var(--bs-mch-black);
    }
  }

  .icon svg {
    width: ${px2rem(25)};
    height: ${px2rem(21)};
    ${mq.lessThan('largestTablet')`
      margin: 0;
    `}
  }

  .ReactVirtualized__Masonry {
    outline: none !important;
  }

  .boxed-text {
    font-size: ${tokens.fontSize[1].value};
    line-height: ${tokensRenamed.lineHeights[6].value};
    padding: ${px2rem(2)} ${px2rem(10)};
    font-weight: ${tokens.fontWeights.artBaselHeadline0.value};
    text-transform: ${tokens.textCase.uppercase.value};
    color: var(--bs-mch-black);
    border: ${px2rem(1)} solid var(--bs-mch-black);
    border-radius: ${px2rem(3)};
  }

  .events-exhibitions__disclamer {
    font-size: ${tokens.fontSize[1].value};
    margin: ${px2rem(-20)} 0 ${px2rem(20)} 0;
    color: ${tokens.color.light.base.neutrals['700'].value};
    ${mq.greaterThan('desktop')`
      font-size: ${tokens.fontSize[1].value};
    `}
  }

  .additional-info-link,
  .virtual-url-link {
    text-decoration: underline;
  }

  .virtual-url-link {
    color: ${tokens.color.light.base.alerts.blue['700'].value};
    width: ${px2rem(225)};
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: ${px2rem(10)} 0;
  }

  .location-detail {
    color: var(--bs-mch-gray-500);
  }

  .push-share-button-left {
    margin-left: auto;
    ${mq.lessThan('desktop')`
      margin-left: unset;
    `}
  }
`

export default Styles
